export default __webpack_public_path__ + "static/media/cliffs-in-sea.0be8514b.jpg";